import api from '@/services/api';

export default {
	async getNotificationsUnreadCount ({ commit }) {
		const response = await api.notifications.getNotificationsUnreadCount();
		if (!response) {
			return;
		}
		commit('setUnreadCount', response.count);
	},

	resetUnreadCount ({ commit }) {
		commit('setUnreadCount', 0);
	}
};
